import reducer from './lib/reducer';
import connectResource from './lib/connect-resource';

export default {
  connectResource,
  reducer,
};
